var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.25,
  d: "M11.928 3.468 2.487 12.91a.8.8 0 0 0-.219.411l-.918 4.76a.397.397 0 0 0 .465.466l4.76-.92a.8.8 0 0 0 .411-.217l9.442-9.442m-4.5-4.5 1.808-1.808a3.182 3.182 0 1 1 4.5 4.5l-1.808 1.808m-4.5-4.5 4.5 4.5"
})));
export default SvgIconEdit;